import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=2d479718&"
import script from "./EditProfileForm.vue?vue&type=script&lang=js&"
export * from "./EditProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d479718')) {
      api.createRecord('2d479718', component.options)
    } else {
      api.reload('2d479718', component.options)
    }
    module.hot.accept("./EditProfileForm.vue?vue&type=template&id=2d479718&", function () {
      api.rerender('2d479718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Pages/UserProfile/EditProfileForm.vue"
export default component.exports